import TestTripIcon from "components/Dashboard/VehicleAnalytics/PageLayout/Analytics/Icons/TestTrip";

export const EOLConfirmationPopup = {
  title: "Test in progress. Are you sure you want to navigate ?",
  className: "navigate-confirm-popup",
};

export const WithoutOrganisationPopup = {
  title: "No Access to any Organization",
  content: <>Please contact Admin to add you to an Organisation.</>,
  okText: "Logout",
  width: 480,
  className: "no-org-modal",
};

export const TestRideSubmissionPopup = {
  title: "Create a Test Ride",
  content: <>Submit this trip for Test Ride Analysis?</>,
  icon: <TestTripIcon style={{ color: '#000000', fontSize: '60px' }} />,
  okText: "Submit",
  width: 480,
  height: 200,
  className: "no-org-modal",
}


export const TestRideSubmissionReTryPopup = {
  title: "Retry a Test Ride",
  content: <>Previouse test ride is Faild. Are you sure retry the Test Ride Analysis?</>,
  icon: <TestTripIcon style={{ color: '#000000', fontSize: '60px' }} />,
  okText: "Retry",
  width: 480,
  height: 200,
  className: "no-org-modal",
}

export const TestRideSubmissionInfoPopup = {
  title: "Create a Test Ride",
  content: <>Please wait... Another test ride analysis is currently in progress</>,
  icon: <TestTripIcon style={{ color: '#000000', fontSize: '60px' }} />,
  width: 480,
  height: 200,
}
